import { render, staticRenderFns } from "./VesselPrintShipTypeIndividualPieChart.vue?vue&type=template&id=34613534&scoped=true&"
import script from "./VesselPrintShipTypeIndividualPieChart.vue?vue&type=script&lang=js&"
export * from "./VesselPrintShipTypeIndividualPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34613534",
  null
  
)

export default component.exports